function copy(value, context) {
  if (value == null)
    return value;
  if (context.replacementContext.elementHtmlIds.has(value))
    return void 0;
  context.replacementContext.elementHtmlIds.add(value);
  return value;
}
export {
  copy
};
//# sourceMappingURL=element-id.js.map